import React from "react";
import { useEffect, useState, createContext, useRef } from 'react';
import request from '../../../Helpers/API';
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import SaveIcon from '@mui/icons-material/Save';
import { TextField, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { LoaderScreen } from "../../components/LoaderScreen";

export const RegistrosCandidatosRefacturacionSection = ({ data, botones, actualiza }) => {
    const [candidatos, setCandidatos] = useState([]);
    const [refacturaciones, setRefacturaciones] = useState([]);
    const [origenes, setOrigenes] = useState([]);
    const [reversas, setReversas] = useState([]);
    const [selectedCandidato, setSelectedCandidato] = useState();
    const [selectedRefacturacion, setSelectedRefacturacion] = useState();
    const [selectedReversa, setSelectedReversa] = useState();
    const [vista, setVista] = useState("DETALLE");
    const [search, setSearch] = useState("");
    const [searchSerie, setSearchSerie] = useState("");
    const [searchFolio, setSearchFolio] = useState("");
    const [searchReversas, setSearchReversas] = useState("");
    const [searchReversasSerie, setSearchReversasSerie] = useState("");
    const [searchReversasFolio, setSearchReversasFolio] = useState("");
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });


    useEffect(() => {
        setRefacturaciones([]);
        setOrigenes([]);
        setReversas([])
        setSelectedRefacturacion();
        setSelectedCandidato();
        setSearch("");
        setSearchReversas("");
        setSearchReversasSerie("");
        setSearchReversasFolio("");
        setCandidatos(data);
    }, [data]);

    const cambiarVista = (nuevaVista) => {
        setVista(nuevaVista);
        setSelectedRefacturacion();
    };

    const onSearchDocumento = (documento, serie, folio) => {
        if (documento === '')
            documento = '-1'
        if (serie === '')
            serie = '-1'
        if (folio === '')
            folio = '-1'
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(`ListadoInvoiceMoviemientos/BuscarDocumentoInvoice?documento=${documento}&serie=${serie}&folio=${folio}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setOrigenes(result);
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("DASHBOARD FISCAL", JSON.stringify(error), "error");
                    return;
                });
        });
    };

    const onSearchDocumentoReversas = (documento, serie, folio) => {
        if (documento === '')
            documento = '-1'
        if (serie === '')
            serie = '-1'
        if (folio === '')
            folio = '-1'
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(`ListadoInvoiceMoviemientos/BuscarDocumentoInvoice?documento=${documento}&serie=${serie}&folio=${folio}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setReversas(result);
                    resolve(result);
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("DASHBOARD FISCAL", JSON.stringify(error), "error");
                    reject(error);
                });
        });
    };

    const onSearchDetalle = (documento, von_no) => {
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(`ListadoInvoiceMoviemientos/ObtenerDetalleCandidatos?document_no=${documento}&von_no=${von_no}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setRefacturaciones(result);
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("DASHBOARD FISCAL", JSON.stringify(error), "error");
                    return;
                });
        });
    };

    const handleClickCandidato = (documento, von_no) => {

        setSelectedCandidato(prev => {
            // 🔁 si ya está seleccionado, lo desmarca todo
            if (prev === documento) {
                setSelectedRefacturacion(null);
                setSelectedReversa(null);
                return null;
            }

            // 👉 nuevo seleccionado
            const candidato = candidatos.find(c => c.document_no === documento);

            setSelectedRefacturacion(null);
            setSelectedReversa(null);

            onSearchDetalle(documento, von_no);

            if (candidato?.document_refacturacion) {
                setSelectedRefacturacion(candidato.document_refacturacion);
            }

            if (candidato?.document_reversa) {
                onSearchDocumentoReversas(
                    candidato?.document_reversa,
                    '',
                    ''
                ).then(() => {
                    setSearchReversas(candidato?.document_reversa);
                    setSearchReversasSerie('');
                    setSearchReversasFolio('');
                    setSelectedReversa(candidato?.document_reversa);
                });
            }

            return documento;
        });
    };

    const handleSelectRefacturacion = (documento) => {
        setSelectedRefacturacion(prev =>
            prev === documento ? "" : documento
        );
    };

    const handleSelectReversa = (documento) => {
        setSelectedReversa(prev =>
            prev === documento ? "" : documento
        );
    };
    const onAplicar = () => {
        setLoader({ ...loader, mostrar: true });

        if (selectedCandidato && !selectedRefacturacion && selectedReversa) {
            Swal.fire("Advertencia", "Debe seleccionar un documento del detalle", "warning");
            setLoader({ ...loader, mostrar: false });
            return;
        }

        if (selectedCandidato && selectedRefacturacion && !selectedReversa) {
            Swal.fire("Advertencia", "Debe seleccionar un documento de reversa", "warning");
            setLoader({ ...loader, mostrar: false });
            return;
        }

        if (selectedRefacturacion === 0 || selectedRefacturacion === "0") {
            Swal.fire("Advertencia", "Debe seleccionar un documento del detalle valido", "warning");
            setLoader({ ...loader, mostrar: false });
            return;
        }

        if (selectedReversa === 0 || selectedReversa === "0") {
            Swal.fire("Advertencia", "Debe seleccionar un documento de reversa valido", "warning");
            setLoader({ ...loader, mostrar: false });
            return;
        }

        const candidato = candidatos.find(c => c.document_no === selectedCandidato);
        const refacturacion = refacturaciones.find(r => r.document_no === selectedRefacturacion);
        const origen = origenes.find(o => o.documento === selectedRefacturacion);
        const reversa = reversas.find(v => v.documento === selectedReversa);

        // importe del candidato
        const importeCandidato = candidato?.importe_venta || 0;
        const importeReversa = reversa?.importe || 0;

        // importe dependiendo de la vista
        let importeSeleccionado = 0;

        if (vista === "DETALLE") {
            importeSeleccionado = refacturacion?.importe_venta || 0;
        } else if (vista === "BUSQUEDA") {
            importeSeleccionado = origen?.importe || 0;
        }

        // comparación (con abs por si vienen negativos)
        if (candidato && refacturacion || candidato && origen) {
            if (Math.trunc(Math.abs(importeCandidato)) !== Math.trunc(Math.abs(importeSeleccionado))) {
                Swal.fire(
                    "Advertencia",
                    "El importe del candidato y el documento de refacturación no coinciden",
                    "warning"
                );
                setLoader({ ...loader, mostrar: false });
                return;
            }
        }

        if (candidato && reversa) {
            if (Math.trunc(Math.abs(importeCandidato)) !== Math.trunc(Math.abs(importeReversa))) {
                Swal.fire(
                    "Advertencia",
                    "El importe del candidato y el documento de reversa no coinciden",
                    "warning"
                );
                setLoader({ ...loader, mostrar: false });
                return;
            }
        }

        if (selectedCandidato && !selectedRefacturacion && !selectedReversa) {
            Swal.fire({
                title: "¿Estás seguro?",
                text: "No tienes seleccionado ningun documento para vincular el candidato  ¿Deseas continuar?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, continuar",
                cancelButtonText: "Cancelar"
            }).then((result) => {

                if (!result.isConfirmed) return;

                const post = {
                    document_candidato: selectedCandidato,
                    document_refacturacion: 0,
                    document_reversa: 0
                };
                request
                    .post("ListadoInvoiceMoviemientos/AplicarRefacturacion", post)
                    .then(() => {
                        setLoader({ ...loader, mostrar: false });

                        Swal.fire(
                            "Éxito",
                            "Refacturacion aplicada con éxito",
                            "success"
                        );

                        actualiza();
                    })
                    .catch((error) => {
                        setLoader({ ...loader, mostrar: false });
                        Swal.fire(
                            "Error",
                            JSON.stringify(error),
                            "error"
                        );
                    });
            });

            return;
        }


        const post = {
            document_candidato: selectedCandidato,
            document_refacturacion: selectedRefacturacion,
            document_reversa: selectedReversa
        };
        request
            .post("ListadoInvoiceMoviemientos/AplicarRefacturacion", post)
            .then(() => {
                setLoader({ ...loader, mostrar: false });

                Swal.fire(
                    "Éxito",
                    "Refacturacion aplicada con éxito",
                    "success"
                );

                actualiza();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "Error",
                    JSON.stringify(error),
                    "error"
                );
            });
    };

    const refacturacionesFiltradas = refacturaciones.filter((det) =>
        (det.document_no || "").toString().toLowerCase().includes(search.toLowerCase())
    );


    return (
        <div className="listado-fiscal-invoicemovimientos-container">
            <LoaderScreen loader={loader} />
            <div className="listado-fiscal-invoicemovimientos-container-izquierda">
                <div className="listado-fiscal-invoicemovimientos-container-tabla scroll">
                    <table>
                        <thead>
                            <tr>
                                <th colSpan={6}>
                                    Candidatos
                                </th>
                            </tr>
                            <tr>
                                <th></th>
                                <th>
                                    Sucursal
                                </th>
                                <th>
                                    <div>ID Cliente</div>
                                </th>
                                {/* <th>
                                    <div>Cliente</div>
                                </th> */}
                                <th>
                                    <div>Documento</div>
                                </th>
                                <th>
                                    <div>Serie Fiscal</div>
                                </th>
                                {/* <th>
                                    <div>Folio Fiscal</div>
                                </th> */}
                                <th>
                                    <div>Importe</div>
                                </th>
                                {/* <th>
                                    <div>Serie</div>
                                </th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {candidatos.map((can) => (
                                <tr
                                    onClick={() => handleClickCandidato(can.document_no, can.von_no)} className={selectedCandidato === can.document_no ? "selected-row" : ""}
                                >
                                    <td>{can.document_refacturacion != null && can.document_refacturacion != "" ? <span style={{ color: 'green' }}>✔</span> : <span style={{ color: 'orange' }}>⚠</span>}</td>
                                    <td className="ta-center">{can.sucursal}</td>
                                    <td className="ta-center">{can.idcliente}</td>
                                    {/* <td className="ta-left">{can.razonsocial}</td> */}
                                    <td className="ta-center">{can.document_no}</td>
                                    <td className="ta-center">{can.serie} - {can.folio}</td>
                                    {/* <td className="ta-center">{can.folio}</td> */}
                                    <td className="ta-right">{FormatMoney(can.importe_venta, 0)}</td>
                                    {/* <td className="ta-center">{can.von_no}</td> */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="listado-fiscal-invoicemovimientos-container-derecha">
                <div className="listado-fiscal-invoicemovimientos-container-derecha-header">
                    {vista === "BUSQUEDA" && (
                        <div className="listado-fiscal-invoicemovimientos-container-buscador">
                            <TextField
                                size="small"
                                fullWidth
                                sx={{ mt: 0.2 }}
                                variant="outlined"
                                placeholder="Buscar documento..."
                                value={search}
                                onChange={(e) => {
                                    const value = e.target.value;

                                    // solo números
                                    if (/^\d*$/.test(value)) {
                                        setSearch(value);
                                    }
                                }}
                            />
                            <TextField
                                size="small"
                                fullWidth
                                sx={{ mt: 0.2 }}
                                variant="outlined"
                                placeholder="Buscar serie fiscal..."
                                value={searchSerie}
                                onChange={(e) => {
                                    setSearchSerie(e.target.value);
                                }}
                            />

                            <TextField
                                size="small"
                                fullWidth
                                sx={{ mt: 0.2 }}
                                variant="outlined"
                                placeholder="Buscar folio fiscal..."
                                value={searchFolio}
                                onChange={(e) => {
                                    const value = e.target.value;

                                    // solo números
                                    if (/^\d*$/.test(value)) {
                                        setSearchFolio(value);
                                    }
                                }}
                            />

                            <Button
                                variant="contained"
                                onClick={() => onSearchDocumento(search, searchSerie, searchFolio)}
                            >
                                <SearchIcon />
                            </Button>

                            <Button
                                variant="contained"
                                onClick={() => cambiarVista("DETALLE")}
                                sx={{ whiteSpace: "nowrap", px: 2, width: 60 }}
                            >
                                Detalle
                            </Button>
                        </div>
                    )}
                    {vista === "DETALLE" && (
                        <div className="listado-fiscal-invoicemovimientos-container-buscador">
                            <TextField
                                size="small"
                                fullWidth
                                variant="outlined"
                                placeholder="Buscar documento..."
                                value={search}
                                onChange={(e) => {
                                    const value = e.target.value;

                                    // solo números
                                    if (/^\d*$/.test(value)) {
                                        setSearch(value);
                                    }
                                }}
                            />
                            <Button
                                variant="contained"
                                sx={{ whiteSpace: "nowrap", px: 2 }}
                                onClick={() => cambiarVista("BUSQUEDA")}
                            >
                                Usar invoice
                            </Button>
                        </div>
                    )}
                </div>
                {vista === "DETALLE" && (
                    <div className="listado-fiscal-invoicemovimientos-container-tabla scroll">
                        <table>
                            <thead>
                                <tr>
                                    <th colSpan={6}>
                                        Detalle
                                    </th>
                                </tr>
                                <tr>
                                    <th>
                                        Documento
                                    </th>
                                    <th>
                                        <div>Cliente</div>
                                    </th>
                                    <th>
                                        <div>Serie Fiscal</div>
                                    </th>
                                    <th>
                                        <div>Folio Fiscal</div>
                                    </th>
                                    <th>
                                        <div>Importe</div>
                                    </th>
                                    <th>
                                        <div>Batch</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {refacturacionesFiltradas.map((det) => {
                                    return (
                                        <tr onClick={() => handleSelectRefacturacion(det.document_no)} className={selectedRefacturacion === det.document_no ? "selected-row" : ""}>
                                            <td className="ta-center">{det.document_no}</td>
                                            <td className="ta-center">{det.cliente}</td>
                                            <td className="ta-center">{det.serie}</td>
                                            <td className="ta-center">{det.folio}</td>
                                            <td className="ta-right">{FormatMoney(det.importe_venta)}</td>
                                            <td className="ta-center">{det.batch}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
                {vista === "BUSQUEDA" && (
                    <div className="listado-fiscal-invoicemovimientos-container-tabla scroll">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        Documento
                                    </th>
                                    <th>
                                        <div>Fecha</div>
                                    </th>
                                    <th>
                                        <div>Importe</div>
                                    </th>
                                    <th>
                                        <div>Serie Fiscal</div>
                                    </th>
                                    <th>
                                        <div>Folio Fiscal</div>
                                    </th>
                                    <th>
                                        <div>Batch</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {origenes.map((og) => {
                                    return (
                                        <tr onClick={() => handleSelectRefacturacion(og.documento)} className={selectedRefacturacion === og.documento ? "selected-row" : ""}>
                                            <td className="ta-center">{og.documento}</td>
                                            <td className="ta-center">{new Date(og.fecha).toLocaleDateString("es-MX", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric"
                                            })}</td>
                                            <td className="ta-right">{FormatMoney(og.importe)}</td>
                                            <td className="ta-center">{og.serie_fiscal}</td>
                                            <td className="ta-center">{og.folio_fiscal}</td>
                                            <td className="ta-center">{og.batch}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}


                <div className="listado-fiscal-invoicemovimientos-container-tabla scroll" style={{ marginTop: "10px" }}>
                    <div className="listado-fiscal-invoicemovimientos-container-buscador">
                        <TextField
                            size="small"
                            fullWidth
                            sx={{ mt: 0.2 }}
                            variant="outlined"
                            placeholder="Buscar documento..."
                            value={searchReversas}
                            onChange={(e) => {
                                const value = e.target.value;

                                // solo números
                                if (/^\d*$/.test(value)) {
                                    setSearchReversas(value);
                                }
                            }}
                        />

                        <TextField
                            size="small"
                            fullWidth
                            sx={{ mt: 0.2 }}
                            variant="outlined"
                            placeholder="Buscar serie fiscal..."
                            value={searchReversasSerie}
                            onChange={(e) => {
                                setSearchReversasSerie(e.target.value);
                            }}
                        />

                        <TextField
                            size="small"
                            fullWidth
                            sx={{ mt: 0.2 }}
                            variant="outlined"
                            placeholder="Buscar folio fiscal..."
                            value={searchReversasFolio}
                            onChange={(e) => {
                                const value = e.target.value;

                                // solo números
                                if (/^\d*$/.test(value)) {
                                    setSearchReversasFolio(value);
                                }
                            }}
                        />

                        <Button
                            variant="contained"
                            onClick={() => onSearchDocumentoReversas(searchReversas, searchReversasSerie, searchReversasFolio)}
                        >
                            <SearchIcon />
                        </Button>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th colSpan={6}>
                                    Reversas
                                </th>
                            </tr>
                            <tr>
                                {/* <th>
                            </th> */}
                                <th>
                                    Documento
                                </th>
                                <th>
                                    <div>Fecha</div>
                                </th>
                                <th>
                                    <div>Importe</div>
                                </th>
                                <th>
                                    <div>Serie Fiscal</div>
                                </th>
                                <th>
                                    <div>Folio Fiscal</div>
                                </th>
                                <th>
                                    <div>Batch</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {reversas.map((rev) => {
                                return (
                                    <tr
                                        onClick={() => handleSelectReversa(rev.documento)} className={selectedReversa === rev.documento ? "selected-row" : ""}
                                    >
                                        <td className="ta-center">{rev.documento}</td>
                                        <td className="ta-center">{new Date(rev.fecha).toLocaleDateString("es-MX", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        })}</td>
                                        <td className="ta-right">{FormatMoney(rev.importe)}</td>
                                        <td className="ta-center">{rev.serie_fiscal}</td>
                                        <td className="ta-center">{rev.folio_fiscal}</td>
                                        <td className="ta-center">{rev.batch}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    <div className="listado-fiscal-invoicemovimientos-container-derecha-footer">
                        {botones?.aplicar && (
                            <div className="buttons">
                                <button
                                    className="listado-fiscal-invoicemovimientos-aplicar"
                                    onClick={() => onAplicar()}
                                >
                                    <SaveIcon /> Aplicar
                                </button>
                            </div>)}
                    </div>
                </div>
            </div>
        </div>
    );
};
